import {useTranslation} from '@aboutyou/i18n';
import {mobileOnly, Text} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {WishlistSortingButton} from '../WishlistSortingButton/WishlistSortingButton';

interface WishlistHeaderProps {
  filterVariant: 'flyout' | 'dropdown';
}

export const WishlistHeader: React.FC<
  React.PropsWithChildren<WishlistHeaderProps>
> = ({children, filterVariant}) => {
  const {t} = useTranslation();

  return (
    <>
      <Wrapper>
        <StyledTitle
          color="Black"
          size="px32"
          weight="heavy"
          data-testid="WishlistHeaderTitle"
        >
          {t('Wishlist')}
        </StyledTitle>
        <FilterWrapper>
          <WishlistSortingButton variant={filterVariant} />
        </FilterWrapper>
      </Wrapper>
      {children}
    </>
  );
};

const FilterWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: end;

  ${mobileOnly(css`
    margin-right: 5px;
  `)}
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;

  &::before {
    content: '';

    ${mobileOnly(
      css`
        flex: 1;
      `,
    )}
  }
`;

const StyledTitle = styled(Text)`
  ${mobileOnly(css`
    font-size: 1.25rem;
  `)}
`;
